import React, { useState } from 'react';
import './ContactPage.css';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', university: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="cp-page">
      <div className="cp-hero">
        <div className="cp-hero-inner">
          <span className="section-tag">We're Here to Help</span>
          <h1 className="cp-title">Contact <span className="gold-text">Us</span></h1>
          <p className="cp-sub">Ready to start your Malaysian university journey? Reach out and our expert counsellors will guide you — completely free of charge.</p>
        </div>
      </div>

      <div className="cp-body">
        <div className="cp-grid">
          <div className="cp-left">
            <h2 className="cp-section-h">Get in Touch</h2>
            <p className="cp-section-p">We're available via WhatsApp, email, or our enquiry form. Expect a reply within a few hours during business hours.</p>

            <div className="cp-info-cards">
              <a href="https://wa.me/601169479883" target="_blank" rel="noopener noreferrer" className="cp-info-card wa-card">
                <div className="cp-info-icon">💬</div>
                <div>
                  <div className="cp-info-label">WhatsApp (Fastest)</div>
                  <div className="cp-info-value">+60 1169479883</div>
                  <div className="cp-info-note">Click to chat now →</div>
                </div>
              </a>
              <a href="mailto:studiline.bd@gmail.com" className="cp-info-card email-card">
                <div className="cp-info-icon">📧</div>
                <div>
                  <div className="cp-info-label">Email Us</div>
                  <div className="cp-info-value">studiline.bd@gmail.com</div>
                  <div className="cp-info-note">Click to send email →</div>
                </div>
              </a>
              <div className="cp-info-card">
                <div className="cp-info-icon">📍</div>
                <div>
                  <div className="cp-info-label">Location</div>
                  <div className="cp-info-value">Kuala Lumpur, Malaysia</div>
                  <div className="cp-info-note">Serving students globally</div>
                </div>
              </div>
              <div className="cp-info-card">
                <div className="cp-info-icon">🕐</div>
                <div>
                  <div className="cp-info-label">Office Hours</div>
                  <div className="cp-info-value">Mon – Sat, 9am–6pm MYT</div>
                  <div className="cp-info-note">WhatsApp available 24/7</div>
                </div>
              </div>
            </div>

            <div className="cp-quick-actions">
              <h3>Quick Actions</h3>
              <a href="https://wa.me/601169479883?text=Hi! I want to apply to a Malaysian university. Please help me." target="_blank" rel="noopener noreferrer" className="cp-quick-btn wa">
                💬 Start Application on WhatsApp
              </a>
              <a href="https://wa.me/601169479883?text=Hi! I need help choosing a university in Malaysia." target="_blank" rel="noopener noreferrer" className="cp-quick-btn wa-2">
                🎓 Get University Advice
              </a>
              <a href="https://wa.me/601169479883?text=Hi! I have questions about student visa for Malaysia." target="_blank" rel="noopener noreferrer" className="cp-quick-btn wa-3">
                📋 Ask About Visa Process
              </a>
            </div>
          </div>

          <div className="cp-right">
            {submitted ? (
              <div className="cp-success">
                <div className="cp-success-icon">✅</div>
                <h3>Message Sent!</h3>
                <p>Thank you, <strong>{form.name || 'there'}</strong>! We've received your enquiry and will contact you within 24 hours.</p>
                <p style={{ marginTop: '8px' }}>For faster response, WhatsApp us at <strong>+60 1169479883</strong>.</p>
                <button onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', university: '', message: '' }); }} className="cp-reset-btn">
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="cp-form" onSubmit={handleSubmit}>
                <h3 className="cp-form-title">Send Us an Enquiry</h3>
                <p className="cp-form-sub">Fill in the form below and we'll get back to you promptly.</p>

                <div className="cp-form-row">
                  <div className="cp-form-group">
                    <label>Full Name *</label>
                    <input type="text" name="name" placeholder="Your full name" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="cp-form-group">
                    <label>Email Address *</label>
                    <input type="email" name="email" placeholder="your@email.com" value={form.email} onChange={handleChange} required />
                  </div>
                </div>

                <div className="cp-form-row">
                  <div className="cp-form-group">
                    <label>Phone / WhatsApp *</label>
                    <input type="tel" name="phone" placeholder="+60 12-XXX XXXX" value={form.phone} onChange={handleChange} required />
                  </div>
                  <div className="cp-form-group">
                    <label>Preferred University (optional)</label>
                    <input type="text" name="university" placeholder="e.g. APU, Taylor's, IMU..." value={form.university} onChange={handleChange} />
                  </div>
                </div>

                <div className="cp-form-group">
                  <label>Your Message *</label>
                  <textarea name="message" placeholder="Tell us your education level, course interest, budget, or any questions..." value={form.message} onChange={handleChange} rows={5} required></textarea>
                </div>

                <button type="submit" className="cp-submit-btn">
                  Send Enquiry <span>→</span>
                </button>
                <p className="cp-privacy">🔒 Your information is private and secure. We never spam.</p>
              </form>
            )}
          </div>
        </div>

        <div className="cp-faq">
          <h2 className="cp-faq-title">Frequently Asked <span className="gold-text">Questions</span></h2>
          <div className="cp-faq-grid">
            {[
              { q: 'How long does the application process take?', a: 'Most applications are processed within 2–4 weeks. Our team will keep you updated every step of the way.' },
              { q: 'Are your consultation services free?', a: 'Yes! Our counselling and guidance services are completely free of charge for students.' },
              { q: 'Can you help with student visa applications?', a: 'Absolutely. We guide you through the entire Malaysia student visa (RM pass) application process.' },
              { q: 'Do you help with accommodation in Malaysia?', a: 'Yes. We help students find safe, affordable accommodation near their chosen university.' },
              { q: 'Which countries do your students come from?', a: 'We serve students primarily from Bangladesh, but assist students from across South Asia and beyond.' },
              { q: 'What intake months are available?', a: 'Most Malaysian universities have intakes in January, May, and September. We\'ll advise based on your timeline.' },
            ].map((faq, i) => (
              <div key={i} className="cp-faq-item">
                <h4>❓ {faq.q}</h4>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
